import { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (pwd.length < 6) {
      toast.error("Mínimo 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      toast.success("Contraseña actualizada");
      setTimeout(() => navigate("/login"), 2200);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#fcfbfd]" data-testid="reset-page">
      <div className="w-full max-w-md animate-fade-up">
        <p className="text-xs uppercase tracking-[0.3em] text-[#7248ae] mb-3">Nueva contraseña</p>
        <h1 className="font-display text-4xl font-black text-[#1a0f2e] mb-8 tracking-tight">Crea una contraseña</h1>

        {!done ? (
          <form onSubmit={onSubmit} className="space-y-5" data-testid="reset-form">
            <div>
              <Label htmlFor="pwd" className="text-xs uppercase tracking-wider text-[#7248ae] mb-2 block">Nueva contraseña</Label>
              <Input id="pwd" type="password" required value={pwd} onChange={(e)=>setPwd(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                data-testid="reset-pwd-input"
                className="h-12 border-[#b182ec]/50 focus:border-[#3e166c] focus:ring-2 focus:ring-[#b182ec]/30 rounded-xl"
              />
            </div>
            <div>
              <Label htmlFor="pwd2" className="text-xs uppercase tracking-wider text-[#7248ae] mb-2 block">Confirmar contraseña</Label>
              <Input id="pwd2" type="password" required value={pwd2} onChange={(e)=>setPwd2(e.target.value)}
                data-testid="reset-pwd2-input"
                className="h-12 border-[#b182ec]/50 focus:border-[#3e166c] focus:ring-2 focus:ring-[#b182ec]/30 rounded-xl"
              />
            </div>
            <Button type="submit" disabled={loading} data-testid="reset-submit-button"
              className="w-full h-12 rounded-xl bg-[#3e166c] hover:bg-[#7248ae] text-white">
              {loading ? "Actualizando…" : (<><KeyRound className="mr-2 h-5 w-5" />Actualizar contraseña</>)}
            </Button>
            <div className="text-center">
              <Link to="/login" className="text-sm text-[#7248ae] hover:text-[#3e166c]">Volver al login</Link>
            </div>
          </form>
        ) : (
          <div className="p-6 rounded-2xl bg-[#10b981]/10 border border-[#10b981]/30" data-testid="reset-success">
            <div className="w-12 h-12 rounded-full bg-[#10b981] flex items-center justify-center mb-4">
              <CheckCircle2 className="h-6 w-6 text-white" />
            </div>
            <h3 className="font-display text-xl font-bold text-[#1a0f2e] mb-2">Listo</h3>
            <p className="text-[#7248ae]">Tu contraseña se actualizó. Redirigiéndote al login…</p>
          </div>
        )}
      </div>
    </div>
  );
}
